const fileSizeFormat = (size: number) => {
  const i = Math.floor(Math.log(size) / Math.log(1000));

  return `${+(size / 1000 ** i).toFixed(2) * 1}  ${['B', 'kB', 'MB'][i]}`;
};

export default fileSizeFormat;
